import TwinTable from '../../../../../../../../../baseComponents/TwinTable'
import { TableComponentProps } from '../../../../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { CustomRenderString, CustomRenderDateHours } from '../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import { OnRowClick } from '../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/types'
import { addDictionaryExtraLine, dictionaryComplexFromJsonArr } from '../../../../../../../../../utils/globals/dictionary'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import { SellTicketRefundModelType, sellTicketRefundTypeInversed } from '@teinor/erp/types/company/order/sell/sellTicketRefund'
import { DisplayPriceGettingParams } from '../../../../../../../../../baseComponents/Displays/DisplayPrice'
import { useCallback, useMemo, useState } from 'react'
import { getAllWorkingCenters, getEmployees } from '../../../../../../../../../utils/reducers/getters'
import { sortEmployeesByUser } from '../../../../../../../../../utils/globals/employees'
import CustomSelect from '../../../../../../../../../forms/CustomSelect'
import { InputWithLabelMargin } from '../../../../../../../../../forms/Input'
import TwinTrans from '../../../../../../../../../baseComponents/TwinTrans'
import { twinFetchPostJSON } from '../../../../../../../../../utils/globals/data'
import { UseEditDeleteModalProps } from '../../../../../../../../../utils/hooks/useEditDeleteModal'
import { emptyExtraLineFirstSortFunction } from '../../../../../../../../../forms/CustomSelect/functions'
import { TableInstanceType } from '../../../../../../../../../baseComponents/TwinTable/types'
import { HandleSellRefundTicketTy } from '../../types'
import { SwitchButton, TabItems } from '../../../../../../../../../baseComponents/Button/SwitchButton'
import { TPVOrderData } from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/types'

type TableSellTicketRefundListingTPVProps = TableComponentProps & TableSellTicketRefundListingTPVLogicProps & {
    onRowClick?: OnRowClick
    handleSelectTicketRefund: HandleSellRefundTicketTy
}

const TableSellTicketRefundListingTPV: React.FC<TableSellTicketRefundListingTPVProps> = ({ onRowClick, handleSelectTicketRefund, setOpened, completeData}) => {
    const { t, tVars } = useTwinTranslation()
    const { ticketFilter, setTicketFilter, tableInstance, setTableInstance, searchedTicket, setSearchedTicket } = useTableSellTicketRefundListingTPVLogic({ completeData })
    const memoEmployees = useMemo(() => addDictionaryExtraLine(JSON.parse(JSON.stringify(getEmployees() || {}))), [])
    const workingCenters = getAllWorkingCenters()

    const columns: ColumnTableSchema<SellTicketRefundModelType> = [
        {
            id: 'full_assigned_number',
            dataKey: 'full_assigned_number',
            label: t('refund', 'Devolución'),
            sortable: true,
            customRender: (parameterValue, allRowData) => <CustomRenderString value={parameterValue} className={allRowData?.assigned_number ? '' : 'text-red-BA'} />,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('refund', 'Devolución') }
            },
            searchKey: 'SellTicketRefund.full_assigned_number'
        },
        {
            id: 'SellTicketId',
            dataKey: 'SellTicketId',
            label: t('ticket', 'Ticket'),
            sortable: true,
            customRender: (parameterValue, allRowData) => <CustomRenderString value={allRowData?.SellTicket?.full_assigned_number} />,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('ticket', 'Ticket') }
            },
            searchKey: 'SellTicket.full_assigned_number'
        },
        {
            id: 'CustomerId',
            dataKey: 'CustomerId',
            label: t('customer', 'Cliente'),
            searchKey: 'Customer.name',
            minWidth: 130,
            customRender: (_parameterValue, allRowData) => <CustomRenderString value={allRowData?.Customer?.fiscal_name || allRowData?.Customer?.name || ''} />,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('customer', 'Cliente') }
            },
        },
        {
            id: 'WorkingCenterId',
            dataKey: 'WorkingCenterId',
            searchKey: 'WorkingCenter.name',
            searchSingleKey: 'SellTicketRefund.WorkingCenterId',
            label: t('soldBy', 'Vendido por'),
            customRender: (_parameterValue, allRowData) => <CustomRenderString value={allRowData?.WorkingCenter?.name || ''} />,
            searchableComponent: {
                component: 'SearchableComponentsCustomSelectSearchBar',
                extraComponentData: { items: workingCenters || {}, label: t('workingCenter', 'Centro de trabajo') }
            },
            minWidth: 120
        },
        {
            id: 'processed_date',
            dataKey: 'processed_date',
            label: t('createdDate', 'Fecha de creación'),
            customRender: (parameterValue, allRowData) => <CustomRenderDateHours value={parameterValue || allRowData.createdAt} />,
            sortable: true,
            minWidth: 165
        },
        {
            id: 'total_total',
            dataKey: 'total_total',
            label: t('total', 'Total'),
            sortable: true,
            minWidth: 100,
            customRender: (parameterValue, allRowData) => <DisplayPriceGettingParams value={parseFloat(parameterValue)} with_vat={allRowData.with_vat} CurrencyId={allRowData.CurrencyId} />,
        },
        {
            id: 'CreateEmployeeId',
            dataKey: 'CreateEmployeeId',
            label: t('madeBy', 'Realizado por'),
            hideColumnByDefault: true,
            searchKey: 'CreateEmployee.fullname_short',
            customRender: (_parameterValue, allRowData) => {
                const employeeName = allRowData?.CreateEmployee ? allRowData?.CreateEmployee?.fullname_short : allRowData?.ProcessEmployee?.fullname_short
                return <CustomRenderString value={employeeName || ''} />
            },
            searchableComponent: {
                component: 'SearchableComponentsCustomSelectSearchBar',
                extraComponentData: {
                    items: memoEmployees,
                    label: t('madeBy', 'Realizado por'),
                    sortItems: true,
                    sortFunction: sortEmployeesByUser
                }
            },
            searchSingleKey: 'CreateEmployee.id'
        },
    ]
    return (
        <div className='flex flex-auto flex-col'>
            <SellTicketRefundFilters {...{ setTicketFilter, tableInstance, handleSelectTicketRefund, setOpened, setSearchedTicket, ticketFilter }} />
            {
                ticketFilter
                    ? < TwinTable className={'sellTicketsRefundTable mt-5'} name={'sellTicketRefunds'} columns={columns} getDataFrom={'/api/app/order/tpv/sellTicketRefund/getAllSellTicketRefundsComplete'} setTableInstance={setTableInstance} extraWhereSubstituibleParams={ticketFilter} onRowClick={onRowClick} />
                    :  searchedTicket
                    ? <div className='flex flex-auto items-center justify-center regular16'> {tVars('ticketRefundNotFoundWithReference', 'No se ha encontrado ningun ticket de devolución con nº {{full_assigned_number}}', { full_assigned_number: searchedTicket })}</div>
                    : null
            }
        </div>
    )
}

interface TicketFilterProps {
    status?: number
    ['SellTicket.full_assigned_number']?: string
    ['SellTicketRefund.WorkingCenterId']?: any
    ['SellTicketRefund.WorkingCenterStationId']?: any
    ['SellTicketRefund.type']?: any
}
interface TableSellTicketRefundListingTPVLogicProps {
    completeData: TPVOrderData
}
const useTableSellTicketRefundListingTPVLogic = ({ completeData }: TableSellTicketRefundListingTPVLogicProps) => {
    const [ticketFilter, setTicketFilter] = useState<TicketFilterProps | null>({
        'SellTicketRefund.type': { '$notN': 1 },
        'SellTicketRefund.WorkingCenterId': completeData?.cashRegister?.WorkingCenterId,
        "SellTicketRefund.WorkingCenterStationId": completeData?.cashRegister?.WorkingCenterStationId,
    })
    const [tableInstance, setTableInstance] = useState<TableInstanceType>(null)
    const [searchedTicket, setSearchedTicket] = useState<string>('')

    return { ticketFilter, setTicketFilter, tableInstance, setTableInstance, searchedTicket, setSearchedTicket }
}

interface SellTicketRefundFiltersProps extends SellTicketRefundFiltersLogicProps {
}

const SellTicketRefundFilters: React.FC<SellTicketRefundFiltersProps> = ({ ...rest }) => {
    const { t } = useTwinTranslation()
    const { handleSelectFilters, dictWorkingCenters, dictWorkingCenterStations, ticketNumber, setTicketNumber, searchSpecificTicketRefund, searchBySellTicket, ticketRefundNumber, setTicketRefundNumber, handleTicketType, ticketType } = useSellTicketRefundFiltersLogic({ ...rest })
    const items: TabItems[] = [
        {
            element: <TwinTrans transKey={'withoutDeposits'}>Sin depósitos</TwinTrans>
        },
        {
            element: <TwinTrans transKey={'allM'}>Todos</TwinTrans>
        },
    ]
    return (
        <div className='flex gap-30 mb-20 items-end mt-5 '>
            <div>
                <InputWithLabelMargin className='ticket_refund_number_selector min-w-210 product_table_filters ' value={ticketRefundNumber} label={t('ticketRefundNumber', 'Nº de devolución')} onChange={setTicketRefundNumber} onKeyDown={searchSpecificTicketRefund} autoFocus />
            </div> 
            <div>
                <InputWithLabelMargin className='ticket_number_selector_tpv min-w-210 product_table_filters ' value={ticketNumber} label={t('ticketNumber', 'Nº de ticket')} onChange={setTicketNumber} onKeyDown={searchBySellTicket} autoFocus />
            </div> 
            <CustomSelect label={t('workingCenter', 'Centro de trabajo')} items={dictWorkingCenters} className='min-w-210 product_table_filters ' name='WorkingCenterId' onChange={(value) => handleSelectFilters(value, 'SellTicketRefund.WorkingCenterId')} sortFunction={emptyExtraLineFirstSortFunction} value={rest.ticketFilter?.['SellTicketRefund.WorkingCenterId']}/>
            <CustomSelect label={t('workStation', 'Puesto')} items={dictWorkingCenterStations} className='min-w-210 product_table_filters ' name='WorkingCenterStationId' onChange={(value) => handleSelectFilters(value, 'SellTicketRefund.WorkingCenterStationId')} sortFunction={emptyExtraLineFirstSortFunction} value={rest.ticketFilter?.['SellTicketRefund.WorkingCenterStationId']} />
            <SwitchButton className='mr-15' onClick={(val) => handleTicketType(val)} active={ticketType} items={items} />
        </div>
    )
}

interface SellTicketRefundFiltersLogicProps {
    setTicketFilter: React.Dispatch<React.SetStateAction<TicketFilterProps | null>>
    ticketFilter: TicketFilterProps | null
    handleSelectTicketRefund: HandleSellRefundTicketTy
    setOpened: React.Dispatch<UseEditDeleteModalProps>
    tableInstance: TableInstanceType
    setSearchedTicket: React.Dispatch<string>
}

const useSellTicketRefundFiltersLogic = ({ setTicketFilter, ticketFilter, handleSelectTicketRefund, setOpened, tableInstance, setSearchedTicket }: SellTicketRefundFiltersLogicProps) => {
    const workingCenters = getAllWorkingCenters()
    const dictWorkingCenters = useMemo(() => addDictionaryExtraLine(JSON.parse(JSON.stringify(workingCenters || {}))), [workingCenters])
    const WorkingCenterId = ticketFilter?.['SellTicketRefund.WorkingCenterId']
    const dictWorkingCenterStations = useMemo(() => addDictionaryExtraLine(JSON.parse(JSON.stringify(WorkingCenterId ? dictionaryComplexFromJsonArr(dictWorkingCenters?.[WorkingCenterId]?.WorkingCenterStations || []) : {}))), [dictWorkingCenters, WorkingCenterId])
    const [ticketRefundNumber, setTicketRefundNumber] = useState<string>('')
    const [ticketNumber, setTicketNumber] = useState<string>('')
    const [ticketType, setTicketType] = useState<number>(0)
    
    const handleSelectFilters = useCallback((value: any, fieldName: string) => {
        setTicketFilter((old) => {
            const copyOld = JSON.parse(JSON.stringify(old || {}))
            if (value) {
                copyOld[fieldName] = value
            } else {
                delete copyOld[fieldName]
            }
            if (Object.keys(copyOld).length && !copyOld['type']) {
                copyOld['SellTicketRefund.type'] = { '$notN': sellTicketRefundTypeInversed['partialCharged'] }
            }
            delete copyOld['SellTicketRefund.full_assigned_number']
            delete copyOld['SellTicket.full_assigned_number']
            return Object.keys(copyOld).length ? copyOld : null
        })
        tableInstance?.getTableDataFromStart()
    }, [setTicketFilter, tableInstance])

    const handleTicketType = useCallback((val: number) => {
        setTicketType(val)
        setTicketFilter((old) => {
            const copyOld = JSON.parse(JSON.stringify(old || {}))
            if (Object.keys(copyOld).length) {
                if (val) {
                    copyOld['SellTicketRefund.type'] = { '$gteN': sellTicketRefundTypeInversed['sell'] }
                } else {
                    copyOld['SellTicketRefund.type'] = { '$notN': sellTicketRefundTypeInversed['partialCharged'] }
                }
            }
            delete copyOld['SellTicketRefund.full_assigned_number']
            delete copyOld['SellTicket.full_assigned_number']
            return Object.keys(copyOld).length ? copyOld : null
        })
        tableInstance?.getTableDataFromStart()
    }, [setTicketType, setTicketFilter, tableInstance])

    const searchSpecificTicketRefund = useCallback(async (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            let result = null
            if (ticketRefundNumber) {
                result = await twinFetchPostJSON('/api/app/order/tpv/sellTicketRefund/getSpecificSellTicketRefund', {full_assigned_number: ticketRefundNumber.trim()})
            }
            if (result && result.id) {
                handleSelectTicketRefund?.(result.id, result.full_assigned_number)
                setOpened(null)
            } else {
                setSearchedTicket(ticketRefundNumber)
            }
            setTicketRefundNumber('')
            //@ts-ignore
            document.querySelector('.ticket_refund_number_selector input')?.focus()
        }
    }, [ticketRefundNumber, setTicketRefundNumber, handleSelectTicketRefund, setOpened, setSearchedTicket])

    const searchBySellTicket = useCallback(async (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            setTicketFilter(() => {
                return { 'SellTicket.full_assigned_number': ticketNumber }
            })
            setTicketNumber('')
            //@ts-ignore
            document.querySelector('.ticket_number_selector_tpv input')?.focus()
        }
    }, [ticketNumber, setTicketNumber, setTicketFilter])

    return { handleSelectFilters, dictWorkingCenters, dictWorkingCenterStations, ticketNumber, setTicketNumber, searchBySellTicket, searchSpecificTicketRefund, ticketRefundNumber, setTicketRefundNumber, handleTicketType, ticketType }
}



export default TableSellTicketRefundListingTPV
